module.exports = __webpack_public_path__ + "img/shot-5.48d2d6c5.png";